<template>
    <div class="w-h-100" style="background:#fff;">
        <div style="padding:20px;height:90%;">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
/* eslint-disable no-debugger */
import axios from 'axios'
export default {

}
</script>

<style scoped lang='less'>

</style>
